// Messages for operator/Conversations (auto-merged into the i18n catalog by lib/i18n.ts).
export const en = {
  'operator.conversations.head': 'Conversations — Operator',
  'operator.conversations.title': 'Conversations',
  'operator.conversations.subtitle': 'Every shipment chat across all customers',
  'operator.conversations.list.empty': 'No conversations match these filters.',
  'operator.conversations.list.load_more': 'Load more conversations',
  'operator.conversations.select_prompt': 'Select a conversation to read and reply.',
  'operator.conversations.open_shipment': 'Open shipment',
  'operator.conversations.thread.empty': 'No messages yet.',
  'operator.conversations.filter.unread': 'Unread',
  'operator.conversations.filter.status.aria': 'Filter by status',
  'operator.conversations.filter.status.all': 'All statuses',
  'operator.conversations.filter.mode.aria': 'Filter by mode',
  'operator.conversations.filter.mode.all': 'All modes',
  'operator.conversations.filter.customer.aria': 'Filter by customer',
  'operator.conversations.filter.customer.all': 'All customers',
  'operator.conversations.search.aria': 'Search conversations',
  'operator.conversations.search.placeholder': 'Search shipment, HBL, customer…',
  'operator.conversations.composer.aria': 'Reply',
  'operator.conversations.composer.internal_placeholder': 'Internal note…',
  'operator.conversations.composer.placeholder': 'Reply…',
  'operator.conversations.composer.customer': 'Customer',
  'operator.conversations.composer.internal': 'Internal',
  'operator.conversations.composer.send': 'Send',
  'operator.conversations.rail.customer': 'Customer',
  'operator.conversations.rail.status': 'Status',
  'operator.conversations.rail.route': 'Route',
  'operator.conversations.rail.mode': 'Mode',
  'operator.conversations.rail.eta': 'ETA',
  'operator.conversations.rail.tracking': 'Tracking',
  'operator.conversations.rail.leg_eta': 'ETA {eta}',
  'operator.conversations.mode.ship': 'Ocean',
  'operator.conversations.mode.air': 'Air',
  'operator.conversations.mode.truck': 'Truck',
  'operator.conversations.mode.train': 'Rail',
}

export const zhTW = {
  'operator.conversations.head': '對話 — 操作端',
  'operator.conversations.title': '對話',
  'operator.conversations.subtitle': '所有客戶的每筆貨件對話',
  'operator.conversations.list.empty': '沒有符合這些篩選條件的對話。',
  'operator.conversations.list.load_more': '載入更多對話',
  'operator.conversations.select_prompt': '選擇一筆對話以閱讀並回覆。',
  'operator.conversations.open_shipment': '開啟貨件',
  'operator.conversations.thread.empty': '尚無訊息。',
  'operator.conversations.filter.unread': '未讀',
  'operator.conversations.filter.status.aria': '依狀態篩選',
  'operator.conversations.filter.status.all': '所有狀態',
  'operator.conversations.filter.mode.aria': '依運輸方式篩選',
  'operator.conversations.filter.mode.all': '所有運輸方式',
  'operator.conversations.filter.customer.aria': '依客戶篩選',
  'operator.conversations.filter.customer.all': '所有客戶',
  'operator.conversations.search.aria': '搜尋對話',
  'operator.conversations.search.placeholder': '搜尋貨件、HBL、客戶…',
  'operator.conversations.composer.aria': '回覆',
  'operator.conversations.composer.internal_placeholder': '內部備註…',
  'operator.conversations.composer.placeholder': '回覆…',
  'operator.conversations.composer.customer': '客戶',
  'operator.conversations.composer.internal': '內部',
  'operator.conversations.composer.send': '傳送',
  'operator.conversations.rail.customer': '客戶',
  'operator.conversations.rail.status': '狀態',
  'operator.conversations.rail.route': '路線',
  'operator.conversations.rail.mode': '運輸方式',
  'operator.conversations.rail.eta': '預計到達',
  'operator.conversations.rail.tracking': '追蹤',
  'operator.conversations.rail.leg_eta': '預計到達 {eta}',
  'operator.conversations.mode.ship': '海運',
  'operator.conversations.mode.air': '空運',
  'operator.conversations.mode.truck': '卡車',
  'operator.conversations.mode.train': '鐵路',
}
